var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProblems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8828 21.2422C28.0625 19.4062 26.9688 15.3438 26.0312 13.9766C24.5469 11.8672 22.125 10.5 19.3906 10.5H16.5C12.3594 10.5 9 13.8594 9 18V18.0391C9 20.2266 9.9375 22.2188 11.5 23.5859V30.5H21.5V28H24C25.3672 28 26.5 26.9062 26.5 25.5V23H27.75C28.4141 23 28.9609 22.4531 28.9609 21.75C28.9609 21.5938 28.9219 21.3984 28.8828 21.2422ZM21.5 18.9375C21.5 19.1328 21.3438 19.25 21.1875 19.25H19V21.4375C19 21.6328 18.8438 21.75 18.6875 21.75H16.8125C16.6172 21.75 16.5 21.6328 16.5 21.4375V19.25H14.3125C14.1172 19.25 14 19.1328 14 18.9375V17.0625C14 16.9062 14.1172 16.75 14.3125 16.75H16.5V14.5625C16.5 14.4062 16.6172 14.25 16.8125 14.25H18.6875C18.8438 14.25 19 14.4062 19 14.5625V16.75H21.1875C21.3438 16.75 21.5 16.9062 21.5 17.0625V18.9375Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblems);
export default __webpack_public_path__ + "static/media/problems.f2d1572b.svg";
export { ForwardRef as ReactComponent };